import { isEmpty } from '../../../utils/common'
import {IScript} from '../interfaces'

export function dataToScriptsList(data: any[]): IScript[] {
  if (isEmpty(data)) return []

  return data?.map((script: any) => ({
    id: script['id'] || '',
    name: script['name'] || '-',
    description: script?.description
      ? script?.description.length > 50
        ? `${script?.description.substring(0, 50)}...`
        : script?.description
      : '-',
    placement: script['placement'] || '-',
    content: script['content'] || '-',
    updatedBy: script['updated_by']?.['user_name'] || '-',
    updatedAt: script['updated_at'],
    createdAt: script['created_at'],
  }))
}

export function scriptToApiFormat(data: any) {
  return {
    script_name: data.name,
    script_description: data.description || '',
    placement: data.placement,
    script_content: data.content
  }
}
